import React, { Component } from "react";
import * as s from "./CollectionSearchResults.module.scss";
import { inject, observer } from "mobx-react";
import { CollectionStore, FilterStore } from "src/stores";
import {
  Paginator,
  P,
  SingleSelectDropdown,
  DocumentRowItem,
  LoadingRowItem
} from "src/views/shared/components";
import { tx } from "src/libs/i18n";

interface Props {
  collectionStore?: CollectionStore;
  filterStore?: FilterStore;
  isSearching?: boolean;
}

@inject("collectionStore", "filterStore")
@observer
export class CollectionSearchResults extends Component<Props> {
  renderDocumentItem = (document, key) => {
    return <DocumentRowItem key={key} document={document} />;
  };

  renderDisplayInformation = () => {
    const { collectionStore } = this.props;
    const { paginatedDocuments, currentPage, numberOfDocumentResults } = collectionStore;

    let numberOfDocumentsOnPage =
      paginatedDocuments &&
      paginatedDocuments.length > currentPage - 1 &&
      paginatedDocuments[currentPage - 1]?.length;

    return (
      <div className={s.resultsIndicator}>
        <P className={s.resultsIndicatorText}>
          {tx("search.displayingResults", {
            displaying: numberOfDocumentsOnPage,
            totalAmount: numberOfDocumentResults
          })}
        </P>
      </div>
    );
  };

  renderPageInformation = () => {
    const { collectionStore } = this.props;
    const { currentPage, numberOfPages } = collectionStore;

    return (
      <div className={s.pageIndicator}>
        <P className={s.pageIndicatorText}>
          {tx("paginator.pageOf", { currentPage, numberOfPages })}
        </P>
      </div>
    );
  };

  render() {
    const { collectionStore, filterStore, isSearching } = this.props;
    const { setPage, currentPage, numberOfPages, paginatedDocuments } = collectionStore;
    const { setSortOption, sortResultsOptions } = filterStore;

    //Remove certain filter options
    const filteredSortResultOptions = sortResultsOptions.filter(
      e => e.key !== "Relevance"
    );

    return (
      <div className={s.searchResults}>
        <div className={s.resultInformationRow}>
          {!isSearching && this.renderPageInformation()}
          {!isSearching && this.renderDisplayInformation()}
          {!isSearching && (
            <P small className={s.sortResultsLabel}>
              {`${tx("filter.sortBy")}: `}
            </P>
          )}
          {!isSearching && (
            <div className={s.sortResultsDropdownContainer}>
              <SingleSelectDropdown
                toggleOption={setSortOption}
                options={filteredSortResultOptions}
              />
            </div>
          )}
        </div>
        {isSearching && [1, 2, 3, 4, 5, 6].map(i => <LoadingRowItem key={i} />)}
        {paginatedDocuments &&
          paginatedDocuments.length > currentPage - 1 &&
          paginatedDocuments[currentPage - 1]?.map(this.renderDocumentItem)}
        {numberOfPages > 1 && (
          <Paginator
            className={s.searchResultsPagination}
            numberOfPages={numberOfPages}
            currentPage={currentPage}
            setPage={setPage}
          />
        )}
      </div>
    );
  }
}
